import { createStyles, makeStyles, Paper } from '@material-ui/core';
import React from 'react'

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flex: 1,
        },
        heading: {
            marginBottom: theme.spacing(2)
        },
        card: {
            padding: 20,
            marginBottom: theme.spacing(5),
            backgroundColor: '#191D24',
        },
    })
);

export default function Card({ children }) {
    const classes = useStyles();

    return (
        <Paper className={classes.card}>
            {children}
        </Paper>
    )
}
